import { render, staticRenderFns } from "./BulkPatternUpload.vue?vue&type=template&id=85db5240"
import script from "./BulkPatternUpload.vue?vue&type=script&lang=js"
export * from "./BulkPatternUpload.vue?vue&type=script&lang=js"
import style0 from "./BulkPatternUpload.vue?vue&type=style&index=0&id=85db5240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports